// eslint-disable-next-line no-unused-vars
import { array, mixed, number, object, string } from 'yup';

export const joblessMemberSchema = object({
    name: string().required(),
    id: number().required(),
    exp: string().required(),
    howLong: number().required(),
    cause: mixed().nullable(),
    whatAtWork: mixed().nullable(),
    selectedExpectations: array().of(number()),
    otherExpectation: mixed().nullable(),
    lookingForWork: string().required(),
    selectedAnnouncements: array().of(number()),
    otherAnnouncement: mixed().nullable(),
    participates: string().required(),
    participatesExplain: mixed().nullable(),
    cvCount: mixed().nullable(),
    interviewsCount: mixed().nullable(),
    interviewsExplain: mixed().nullable(),
    refusedJob: string().required(),
    selectedJobRefuse: array().of(number()),
    jobRefuseOther: mixed().nullable(),
    obstacles: string().required(),
    obstaclesDescription: mixed().nullable(),
    jobFor: string().required(),
    notLookingForWorkExplain: mixed().nullable(),
    planToFindAJob: string().required()
});
